/**
 * Pastille rouge de l'onglet Missions : le quiz du jour n'est pas répondu.
 *
 * La ressource du jour (app/site) reste une mission à part sur l'écran, mais
 * elle ne pilote plus le point rouge — sinon la pastille restait allumée
 * après la réponse au quiz.
 *
 * Le rattachement se fait par question_id → challenge_date (comme useQuiz),
 * pas seulement par answer_date (date réelle d'écriture). answer_date sert
 * de filet : une réponse écrite aujourd'hui compte aussi.
 */

/** PostgREST peut renvoyer une `date` en 'YYYY-MM-DD' ou avec une heure. */
export function toIsoDate(value: unknown): string | null {
  if (typeof value !== "string" || value.length < 10) return null;
  return value.slice(0, 10);
}

export function isMissionsBadgePending(input: {
  displayToday: string;
  challengeStart: string;
  challengeEnd: string;
  todayQuestionId: string | null | undefined;
  answeredQuestionIds: Iterable<string>;
  /** Une ligne quiz_answers dont answer_date = jour réel. */
  answeredToday?: boolean;
}): boolean {
  const { displayToday, challengeStart, challengeEnd, todayQuestionId } = input;
  if (displayToday < challengeStart || displayToday > challengeEnd) return false;
  // Week-end / jour sans question : rien à répondre → pas de pastille.
  if (!todayQuestionId) return false;
  if (input.answeredToday) return false;
  const answered = new Set(input.answeredQuestionIds);
  return !answered.has(todayQuestionId);
}

export type DailyProgressHint = "quiz" | "challenge";

type ProgressListener = (hint?: DailyProgressHint) => void;

const listeners = new Set<ProgressListener>();

/** Prévenir la barre d'onglets qu'une action du jour vient d'être faite. */
export function notifyDailyProgressChanged(hint?: DailyProgressHint): void {
  for (const listener of listeners) listener(hint);
}

export function subscribeDailyProgressChanged(listener: ProgressListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
